// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"8e05f377","150":"f73c193e","790":"f73c193e"}[chunkId] + ".chunk.css";
};